import Workflow from './base';

import { DomuiError, DynamicData } from '@domui-domain/type';

class Organization extends Workflow {
  constructor() {
    super('organizationwf');
  }

  async getDominoOrganizationId(disId: string) {
    this.setAction('getOrganizationId');
    this.setData({
      idType: 'DISID',
      value: disId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getRegionPkByRegionNfKey(regionNfKey: string) {
    this.setAction('getRegionPkByRegionNfKey');
    this.setData({
      regionNfKey,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getOrganization(dominoId: string, permission?: boolean) {
    this.setAction('getOrganization');
    this.setData({
      id: dominoId,
      permission,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async addMeetingDetails(orgId: string, data: DynamicData) {
    this.setAction('addMeetingDetails');
    this.setData({
      id: orgId,
      putData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateClubContactInfo(orgId: string, data: DynamicData) {
    this.setAction('updateClubContactInfo');
    this.setData({
      id: orgId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async updateMeeting(orgId: string, data: DynamicData) {
    this.setAction('updateMeeting');
    this.setData({
      id: orgId,
      putData: data,
    });
    try {
      const res = await this.putCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async peopleGraphDetails(orgId: string, data: DynamicData) {
    this.setAction('peopleGraphDetails');
    this.setData({
      id: orgId,
      putData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getClubLeadership(
    domOrgId: string,
    startDate: string,
    endDate: string,
    pageNumber: number,
    pageSize: number
  ) {
    this.setAction('getClubLeadership');
    this.setData({
      orgId: domOrgId,
      startDate,
      endDate,
      pageNumber,
      pageSize,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async distClubsStatistics(distOrgId: string, data: DynamicData) {
    this.setAction('distClubsStatistics');
    this.setData({
      id: distOrgId,
      postData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchDistrictOfficers(orgId: string, data: DynamicData) {
    this.setAction('fetchDistrictOfficers');
    this.setData({
      id: orgId,
      putData: data,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async DistrictAssistantGovernors(
    districtId: string,
    pageNumber: number,
    pageSize: number,
    requestBody: DynamicData
  ) {
    this.setAction('districtAssistantGovernors');
    this.setData({
      orgId: districtId,
      pageNumber,
      pageSize,
      requestBody,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async GetDistrictCommitteeRoles(payloadData: DynamicData) {
    this.setAction('getDistrictCommitteeRoles');
    this.setData({
      payloadData,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchOrgDisplayInfo(id: string) {
    this.setAction('fetchOrgDisplayInfo');
    this.setData({ id });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async organizationTypeRoleMapping(orgId: string) {
    this.setAction('organizationTypeRoleMapping');
    this.setData({
      id: orgId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getRelations(dominoId: string) {
    this.setAction('getRelations');
    this.setData({
      id: dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getOrganizationTypeRoleMappingByOrganizationId(dominoId: string) {
    this.setAction('getOrganizationTypeRoleMappingByOrganizationId');
    this.setData({
      id: dominoId,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async findClubsSearch(
    pageNumber: number,
    pageSize: number,
    data: DynamicData
  ) {
    this.setAction('findClubsSearch');
    this.setData({
      pageNumber,
      pageSize,
      putData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getAllDistricts() {
    this.setAction('getAllDistricts');
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getAllClubs(data: DynamicData) {
    this.setAction('getAllClubs');
    this.setData({
      payloadData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getAllDistrictClubs(
    pageNumber: number,
    pageSize: number,
    orgId: string,
    data: DynamicData
  ) {
    this.setAction('getAllDistrictClubs');
    this.setData({
      pageNumber,
      pageSize,
      orgId,
      putData: data,
    });

    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async deleteClubMeeting(dominoId: string) {
    this.setAction('deleteClubMeeting');
    this.setData({ dominoId });
    try {
      const res = await this.deleteCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchClubVendors(riClubId: string, type: string) {
    this.setAction('fetchClubVendors');
    this.setData({
      riClubId,
      type,
    });
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchPotentialVendors() {
    this.setAction('fetchPotentialVendors');

    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async addClubVendor(postData: DynamicData) {
    this.setAction('addClubVendor');
    this.setData({
      putData: postData,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async terminateVendor(postData: DynamicData) {
    this.setAction('terminateVendor');
    this.setData({
      putData: postData,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async organizationDistrictMemberClubAnalytics(postData: DynamicData) {
    this.setAction('organizationDistrictMemberClubAnalytics');
    this.setData({
      putData: postData,
    });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async getClubNameSearch() {
    this.setAction('getClubNameSearch');
    try {
      const res = await this.getCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }

  async fetchRegionOfficerAccess(loginId: string) {
    this.setAction('fetchRegionOfficerAccess');
    this.setData({ postData: { loginId } });
    try {
      const res = await this.postCall();
      return res?.data?.wfRes || res?.data || undefined;
    } catch (error) {
      const typedError = error as DomuiError;
      throw typedError;
    }
  }
}

export default Organization;
